const getUnreadCommentsBySlants = slants => {
  return slants.reduce((result, option) => {
    if (Number(option.commentsUnread) > 0) {
      return result + option.commentsUnread;
    }
    return result;
  }, 0);
};
export { getUnreadCommentsBySlants };
